import { InputNumber, InputNumberProps } from "antd";
import { FC, useEffect, useRef, useState, KeyboardEvent } from "react";
import cn from "classnames";

const ALLOWED_CONTROL_KEYS = [
  "Backspace",
  "Delete",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Tab",
  "Home",
  "End",
  "Enter",
];

const AutoSizeInputNumber: FC<{ value?: number; className?: string; classNames?: any; minWidth?: number; fullWidth?: boolean } & InputNumberProps> = ({
  value,
  classNames,
  className,
  minWidth = 40,
  fullWidth = false,
  onKeyDown,
  ...props
}) => {
  const mirrorRef = useRef<HTMLSpanElement>(null);
  const [width, setWidth] = useState<number | undefined>(minWidth);

  useEffect(() => {
    if (mirrorRef.current) {
      setWidth(Math.max(minWidth,mirrorRef.current.offsetWidth + 80 ))
    }
  }, [value]);

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    const isDigit = /^[0-9]$/.test(e.key);
    const isAllowed = isDigit || ALLOWED_CONTROL_KEYS.includes(e.key) || e.ctrlKey || e.metaKey;
    if (!isAllowed) e.preventDefault();
    onKeyDown?.(e);
  };

  return (
    <div
      className={cn(fullWidth && "w-full")}
      style={{ position: "relative", display: "inline-flex", alignItems: "center" }}
    >
      <span
        ref={mirrorRef}
        style={{
          position: "absolute",
          visibility: "hidden",
          whiteSpace: "pre",
          fontSize: "inherit",
          pointerEvents: "none",
        }}
      >
        {value ?? 0}
      </span>

      <InputNumber
        value={Number(value ?? 0)}
        controls={false}
        onKeyDown={handleKeyDown}
        style={fullWidth ? { width: "100%" } : { width }}
        className={cn("border-none! focus-within:outline-none! focus-within:border-none!", className)}
        {...props}
      />
    </div>
  );
};

export default AutoSizeInputNumber;
